import { render, staticRenderFns } from "./TrackingNumber.vue?vue&type=template&id=a535539e&scoped=true"
import script from "./TrackingNumber.vue?vue&type=script&lang=ts"
export * from "./TrackingNumber.vue?vue&type=script&lang=ts"
import style0 from "./TrackingNumber.vue?vue&type=style&index=0&id=a535539e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a535539e",
  null
  
)

export default component.exports